import { IAlertsQueryParams, AlertActions } from './../services/alerts-model';

import {take} from 'rxjs/operators';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Alert } from '../models/common-model-interface';
import { AlertsService } from '../services/alerts.service';
import { AlertItemComponent } from './alert-item/alert-item.component';
//import { AlertsCountService } from '../services/alerts-count.service';
import { IErrorMessage } from './alert-error/alert-error.component';


@Component({
  selector: 'gn-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {
  @ViewChildren(AlertItemComponent)
  alertItemComponents: QueryList<AlertItemComponent>;
  @Input()
  alertLinks: Array<Alert> = [];
  @Input()
  domain: string;
  @Input()
  alertsUrl: string;
  alertError = false;
  alertsLoading: boolean = false;
  errorMessage: IErrorMessage = {};

  constructor(
    private alertService: AlertsService,
    //private alertsCountService: AlertsCountService,
    private myElement: ElementRef
  ) {}

  ngOnInit(): void {
    const alertQuery: IAlertsQueryParams = {
      page: 0,
      sortedfield: 'sendTime',
      sortorder: 'desc',
      readcount: 0
    };
    this.getAlerts(alertQuery);
  }

  private getAlertNotifications() {
    this.alertService.alertsNotification$.subscribe(alertsNotification => {
      switch (alertsNotification.action) {
        case AlertActions.GET_NEW: {
          //statements;
          console.log(
            `Get new called for  ${JSON.stringify(
              alertsNotification.alerts.map(a => a.userAlertDistributionID)
            )}`
          );
          break;
        }
        case AlertActions.MARK_AS_READ: {
          let alertId = alertsNotification.alerts[0].userAlertDistributionID;
          this.alertLinks = this.alertLinks.filter(
            alerts => alerts.userAlertDistributionID !== alertId
          );
          console.log(`Mark as read called for ${alertId}`);
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  private getAlerts(alertQuery: IAlertsQueryParams) {
    if (this.alertsUrl !== undefined) {
      //this.alertsCountService.getAlertsCount(this.domain).subscribe();

      this.alertsLoading = true;
      const alert$ = this.alertService.getAlerts(this.domain, alertQuery);
      alert$.subscribe(
        alertResponse => {
          if (alertResponse && alertResponse.body &&
            alertResponse.body.listUserAlertDistributionDTO) {
            this.alertLinks = alertResponse.body.listUserAlertDistributionDTO;
          } else  {
            this.alertLinks = []
          }
          this.alertError = false;
          this.checkEmpty();
        },
        () => {
          this.alertError = true;
          this.errorMessage = {
            msgImgUrl: 'img-svcError',
            msgTitle: 'Uh-oh',
            msgBody: `Looks like we can’t show your alerts right now. Please try again later.`
          };
        }
      );
      alert$.pipe(take(1)).subscribe(
        () => {
          this.getAlertNotifications();
          this.alertsLoading = false;
        },
        () => (this.alertsLoading = false)
      );
    }
  }

  checkEmpty(): void {
    //this.alertError = this.alertLinks.length > 0 ? false : true;

    if (this.alertLinks.length > 0) {
      this.alertError = false;
    } else {
      this.alertError = true;
      this.errorMessage = {
        msgImgUrl: 'img-noAlert',
        msgTitle: 'No New Alerts',
        msgBody: `View older or dismissed alerts in your <a href=${
          this.alertsUrl
        }>Alerts Inbox</a>.`
      };
    }
  }

  onDissmissClick(alert: any): void {
    let indexOfDismissedAlert = this.alertLinks.findIndex(
      element => element.userAlertDistributionID === alert.userAlertDistributionID
    );

    this.alertService.dismissAlert(this.domain, alert);

    setTimeout(() => {
      const alertDomElements = this.myElement.nativeElement.querySelectorAll('gn-alert-item a');

      if (indexOfDismissedAlert >= alertDomElements.length) {
        indexOfDismissedAlert = alertDomElements.length - 1;
      }

      if (indexOfDismissedAlert >= 0) {
        alertDomElements[indexOfDismissedAlert].focus();
      }
    }, 0);
    this.checkEmpty();
  }
}
